import { CSSProgressiveBody01Semibold } from "@caisy/league";
import styled from "styled-components";

export const SAddProjectModalSectionsInfoMain = styled.div`
  ${CSSProgressiveBody01Semibold};
  color: var(--text-01);
`;
